module.exports = __webpack_public_path__ + "img/fb.a8e100a0.svg";